import { useState, useEffect, useCallback } from "react";
import { listSessions } from "@/lib/atlasApi";
import { Button } from "@/components/ui/button";
import { Plus, MessageSquare, RefreshCw } from "lucide-react";

export default function SessionManager({ activeId, onSelect, onNew, refreshKey }) {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try { const d = await listSessions(); setSessions(d.sessions || []); }
    catch { /* noop */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh, refreshKey]);

  return (
    <div className="h-full flex flex-col bg-[#0B0F17] border-r border-[#2A364F]" data-testid="session-manager">
      <div className="p-3 border-b border-[#2A364F]">
        <Button
          data-testid="new-session-button"
          onClick={onNew}
          className="w-full bg-[#E05A2B] hover:bg-[#F06B3C] text-white py-2.5 rounded-lg flex items-center justify-center gap-2 font-medium shadow-md transition-all hover:scale-[1.02] active:scale-[0.98]"
        >
          <Plus className="h-4 w-4" /> Nova Ideação
        </Button>
      </div>
      <div className="flex items-center justify-between px-3 py-2">
        <span className="text-[11px] uppercase tracking-widest text-slate-500">Conversas ({sessions.length})</span>
        <button onClick={refresh} className="text-slate-500 hover:text-[#E05A2B]" data-testid="sessions-refresh">
          <RefreshCw className={`h-3.5 w-3.5 ${loading ? "animate-spin" : ""}`} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-2 pb-2 space-y-1">
        {sessions.length === 0 && (
          <p className="text-xs text-slate-500 px-2 py-3" data-testid="sessions-empty">Nenhuma conversa ainda. Comece uma Nova Ideação.</p>
        )}
        {sessions.map((s) => (
          <button
            key={s.session_id}
            data-testid={`session-item-${s.session_id}`}
            onClick={() => onSelect(s.session_id)}
            className={`w-full text-left rounded-lg px-3 py-2.5 transition-colors ${
              activeId === s.session_id
                ? "bg-[#161E2E] border-l-4 border-[#E05A2B] text-white"
                : "text-slate-300 hover:bg-[#161E2E]/60 border-l-4 border-transparent"
            }`}
          >
            <div className="flex items-start gap-2">
              <MessageSquare className="h-3.5 w-3.5 mt-0.5 shrink-0 text-slate-500" />
              <div className="min-w-0">
                <div className="text-sm truncate">{s.title || "Sem título"}</div>
                <div className="text-[10px] text-slate-500">{s.message_count} msgs</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
